import {
	EnhancedGuideInformationWithPageContent,
	FileErrorMap,
	GuideFileErrorMap,
	ParsedPageContentConfigWithFilePath,
	RelativeLink,
	VersionFileErrorMap,
} from '../../types'
import { checkForRelativeLinks } from '../linking'

function checkPageContent(page: ParsedPageContentConfigWithFilePath) {
	const relativeLinks = checkForRelativeLinks({
		content: page.content || '',
		numberOfMatterLines: page.numberOfMatterLines ?? 0,
	})

	return {
		filePath: page.filePath,
		relativeLinks,
	}
}

export function checkRelativeLinks(
	guides: EnhancedGuideInformationWithPageContent[],
): GuideFileErrorMap<RelativeLink> {
	const missingFilesPerGuide: GuideFileErrorMap<RelativeLink> = new Map()

	guides.forEach((guide) => {
		const missingFilesPerVersion: VersionFileErrorMap<RelativeLink> = new Map()

		guide.versionInformation.forEach((version) => {
			const missingFilesPerPage: FileErrorMap<RelativeLink> = new Map()

			version.existingFiles.forEach((page) => {
				const result = checkPageContent(page)
				if (result && result.relativeLinks.length > 0) {
					missingFilesPerPage.set(page.filePath, result.relativeLinks)
				}
			})
			missingFilesPerVersion.set(version.versionFolderPath, missingFilesPerPage)
		})

		missingFilesPerGuide.set(guide.guideFolderPath, missingFilesPerVersion)
	})

	return missingFilesPerGuide
}
